export const themePackSessionKeys = {
  connected: (ownerId: string) => `theme-pack-connected:${ownerId}`,
  rankingExitViewed: (ownerId: string, slug: string) =>
    `theme-pack-ranking-exit-viewed:${ownerId}:${slug}`,
  connectExitViewed: (ownerId: string, slug: string) =>
    `theme-pack-connect-exit-viewed:${ownerId}:${slug}`,
  chatExitBrief: (ownerId: string) => `theme-pack-chat-exit-brief:${ownerId}`,
  chatStarted: (ownerId: string, slug: string) =>
    `theme-pack-chat-started:${ownerId}:${slug}`,
  chatOpen: (ownerId: string, chatId: string) =>
    `theme-pack-chat-open:${ownerId}:${chatId}`,
  chatFirstMessage: (ownerId: string, chatId: string) =>
    `theme-pack-chat-first-message:${ownerId}:${chatId}`,
};
